var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowUp02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 11"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#999",
  clipPath: "url(#icon_arrow_up_02_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 2.3h7.2v7.2M1.51 8.896 7.827 2.7"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_arrow_up_02_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h10v10H0z"
})))));
export default SvgIconArrowUp02;